import { Profile } from "@WahooFitness/cloud-client-types/Profile";

// This is the default remote config for the lobby mfe. This
// will get loaded in if Firebase is not reachable and there are no
// cached remote config settings.
// Make sure to add to this when you create a new remote config key.
//
// Keys where the default min profile is "std" should be removed from code
// and moved to the deprecated folder in Firebase. See docs/FEATURE_FLAGS.md.
export const lobbyDefaultRemoteConfig = {
  SHOW_ROUTES_MIN_PROFILE: Profile.dev,
  SYSTM_CONTENT_DETAILS_BASE_URL: "https://systm.wahoofitness.com/content-details/",
  SYSTM_CONTENT_DETAILS_QUERY_PARAMS: "",
  SUGGESTIONS_COUNT: 7,
  CURATED_ROUTES_MIN_PROFILE: Profile.alpha,
  CURATED_WORKOUTS_LIST: "[]",
  ROUTE_TO_PLAYR: Profile.alpha,
  SYSTM_TRAINING_PLANS_LINK: "systm://training-plans",
  PAYWALL_MODAL_CONFIG: "default",
  SUBSCRIPTION_CARDS: '["default"]',
  FITNESS_ASSESSMENT_PLAN_GROUP_IDS: "[]",
  FIRST_RIDE_ROUTE_ID: 39054742,
  FIRST_RIDE_EVENT_PROMO_ID: 10,
  EXCLUDED_FROM_GOOGLE_HEALTH_SHARING: "[17,18,19,20,21,1328,1332,1333,1334,1338]",
  SUPPORTED_SHARING_APPS: "[1,2,4,6,7,8,9,10,11,12,13,14,15,16,18]",
  CONTENT_DISCOVERY_CONTAINER_IDS:
    '{ "landing": 2, "cycling": 3, "running": 4, "swimming": 5, "mental_training": 7, "strength_training": 8, "yoga": 6 }',
  TRAINING_PROGRESS_BETA_FLAG_MINPROFILE_VERSION: '[{ "minProfile": "std" }]',
  TRAINING_PROGRESS_CYCLING_TRENDS: '[{ "minProfile": "dev" }]',
  CONTENT_DISCOVERY_ROUTE_CATEGORY_ID: 20,
  USE_KC_FOR_MATR: '[{ "minProfile": "dev" }]',
  USE_KC_FOR_TRAINING_PROGRESSIONS_FLAG: '[{ "minProfile": "dev" }]',
  FITNESS_STATE_BETA_FEEDBACK_FLAG: '[{ "minProfile": "dev" }]',
  RUNNING_3DP_FLAG: '[{ "minProfile": "dev" }]',
  RUNNING_3DP_BETA_TAG_FLAG: '[{ "minProfile": "dev" }]',
  DTL_FEEDBACK_BUTTON_FLAG: '[{ "minProfile": "dev" }]',
  TIERED_SUBSCRIPTION_PAYWALL_FLAG: '[{ "minProfile": "dev" }]',
  SOCIAL_SHARE_FLAG: '[{ "minProfile": "dev" }]',
  SOCIAL_SHARE_EDITING_FLAG: '[{ "minProfile": "dev" }]',
  DOWNLOAD_FIT_FLAG: '[{ "minProfile": "dev" }]',
  SEND_TO_APPLE_WATCH_FLAG: '[{ "minProfile": "dev" }]',
  RECOVERY_247_MINPROFILE_VERSION: '[{ "minProfile": "dev" }]',
  RECOVERY_247_FEEDBACK_BUTTON_MIN_PROFILE_VERSION: '[{ "minProfile": "dev" }]',
  RECOVERY_247_HOMEPAGE_UPDATES_MINPROFILE_VERSION: '[{ "minProfile": "dev" }]',
  RTR_DO_NOT_FILTER_FITNESS_APP_IDS: "[]",
  // Long-lived kill-switch; no removal ticket — see docs/FEATURE_FLAGS.md.
  DEBUG_DRAWER_FLAG: '[{ "minProfile": "dev" }]',
};

export type LobbyRemoteConfigKey = keyof typeof lobbyDefaultRemoteConfig;
